import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';

import { AuthentificationService } from '../../providers/Global/authentification.service';

@Component({
  selector: 'app-accueil',
  templateUrl: './accueil.component.html',
  styleUrls: ['./accueil.component.scss']
})
export class AccueilComponent implements OnInit, OnDestroy {

  isLoggedInSub: Subscription;
  initLoginSub: Subscription;

  isLoggedIn = false;
  initLogin = false;
  hidePassword = true;

  formLogin: UntypedFormGroup;

  users = [];

  constructor(private http: HttpClient,
              private router: Router,
              private formBuilder: UntypedFormBuilder,
              private authentificationService: AuthentificationService,
              private snackBar: MatSnackBar) {

  }

  ngOnInit() {
    // Vérifier si l'utilisateur est déjà connecté au chargement
    this.authentificationService.status()
      .then(res => {
        console.log('Utilisateur déjà connecté:', res);
      })
      .catch(err => {
        console.log('Utilisateur non connecté:', err);
      });

    this.isLoggedInSub = this.authentificationService.isLoggedIn.subscribe(message => {
      this.isLoggedIn = message;
      if (this.isLoggedIn === true) {
        // Navigation vers la page import après connexion
        // L'authentification est gérée via les cookies de session Laravel
        this.router.navigate(['import']).then(res => {
          console.log(res);
        });
      }
    });

    this.initLoginSub = this.authentificationService.initLogin.subscribe(message => {
      this.initLogin = message;
    });

    // Formulaire de login avec email et mot de passe
    this.formLogin = this.formBuilder.group({
      identifiant: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }

  ngOnDestroy() {
    if (this.isLoggedInSub) {
      this.isLoggedInSub.unsubscribe();
    }
    if (this.initLoginSub) {
      this.initLoginSub.unsubscribe();
    }
  }

  login(formValue, formValid) {
    console.log('Login');
    console.log(formValue);
    console.log(formValid);
    if (formValid === true) {
      this.authentificationService.login(formValue.identifiant, formValue.password)
        .then(res => {
          console.log(res);
          this.snackBar.open(res);
        })
        .catch(err => {
          console.log(err);
          this.snackBar.open(err, '', {duration: 6000});
        });
    }
  }

  test(formValue, formValid) {
    console.log(formValue);
    console.log(formValid);
    if (formValid === true) {
      this.authentificationService.test(formValue.user)
        .then(res => {
          console.log(res);
          this.snackBar.open(res);
        })
        .catch(err => {
          console.log(err);
          this.snackBar.open(err, '', {duration: 6000});
        });
    }
  }

}
